import { FC, useMemo } from 'react'
import styled from 'styled-components'

import {
  Divider,
  SearchInput,
  SelectableList,
  ButtonsBlock,
} from '@app/ui'
import { SelectElementType, SelectIconType } from '@app/types'

interface ListWithSearchProps {
  elements: SelectElementType[];
  searchString?: string;
  selectIconType?: SelectIconType;
  multiple?: boolean;
  withActions?: boolean;
  confirmDisabled?: boolean;
  disabled?: boolean;
  loading?: boolean;
  paginationLoading?: boolean;
  withPagination?: boolean;
  hasBackendSearch?: boolean;
  onChange: (id: string, selected: boolean) => void
  onSearch: (search: string) => void;
  onConfirm?: () => void;
  onClose?: () => void;
  onLoad?: () => void;
  caption?: string;
}

const ListWithSearch: FC<ListWithSearchProps> = ({
  elements ,
  searchString = '',
  selectIconType,
  multiple,
  withActions,
  confirmDisabled,
  disabled,
  loading,
  paginationLoading,
  withPagination,
  hasBackendSearch,
  onChange,
  onSearch,
  onConfirm,
  onClose,
  onLoad,
  caption,
}) => {

  const suitableElements = useMemo(() => {
    if (hasBackendSearch) return elements

    if (searchString) {
      const searchRegex = new RegExp(searchString, 'i')

      return elements.filter(item => item.title?.search(searchRegex) > -1)
    } else {
      return elements
    }
  }, [ searchString, elements ])

  return(
    <>
      <StyledListContainer>
        <StyledSelectableListWrapper>
          <StyledSelectableList
            className={withActions ? 'with-actions' : ''}
            elements={suitableElements}
            selectIconType={selectIconType}
            multiple={multiple}
            disabled={disabled}
            loading={loading}
            paginationLoading={paginationLoading}
            withPagination={withPagination}
            onChange={onChange}
            onLoad={onLoad}
          />
        </StyledSelectableListWrapper>
      </StyledListContainer>

      {
        withActions && onConfirm && onClose &&
        <StyledActions>
          <ButtonsBlock onConfirm={onConfirm} onClose={onClose} confirmDisabled={confirmDisabled}/>
        </StyledActions>
      }
    </>
  )
}

const StyledListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
`

const StyledSelectableList = styled(SelectableList)`
  flex-grow: 1;
  overflow-y: auto;

  &.with-actions::after {
    content: '';
    display: block;
    height: 120px;
  }
`

const StyledSelectableListWrapper = styled.div`
overflow-y: auto;
`
const StyledActions = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
  padding: 30px 30px 0;
  background: linear-gradient(180deg, rgba(256, 256,256, 0) 0%, #FFF 95%);
`

export default ListWithSearch
